import React from "react";
import { ProcedureImagesSet } from "./ProcedureImagesSet";

export function ProcedureImagesContainer({
  type,
  procedure_drawings_image,
  pdf_image,
  procedure_image_data,
  openLightbox,
}) {
  const withBackImage =
    procedure_drawings_image?.drawing_back_image_with_pins ||
    pdf_image?.back_pdf_image_thumb_url ||
    procedure_image_data?.patient_image_back_thumb_url;

  const isLaser = type === "laser";
  const isCoolSculpting = type === "coolsculpting";

  return (
    <div className="pdfImageContainer">
      <>
        <div className="juvly-subtitle">
          {isLaser ? "Procedure Images" : "Procedure Images - 45 Degrees"}
        </div>
        <ProcedureImagesSet
          drawings_image={procedure_drawings_image?.drawing_image_45}
          rightImage={
            procedure_drawings_image?.drawing_right_image_with_pins_45 ||
            pdf_image?.right_pdf_image_45_url ||
            procedure_image_data?.patient_image_right_45_url
          }
          frontImage={
            procedure_drawings_image?.drawing_front_image_with_pins ||
            pdf_image?.front_pdf_image_url ||
            procedure_image_data?.patient_image_front_url
          }
          leftImage={
            procedure_drawings_image?.drawing_left_image_with_pins_45 ||
            pdf_image?.left_pdf_image_45_url ||
            procedure_image_data?.patient_image_left_45_url
          }
          openLightbox={openLightbox}
        />
      </>
      {!isLaser && (
        <>
          <div className="juvly-subtitle m-t-40">
            Procedure Images - 90 Degrees
          </div>
          <ProcedureImagesSet
            drawings_image={procedure_drawings_image?.drawing_image}
            rightImage={
              procedure_drawings_image?.drawing_right_image_with_pins ||
              pdf_image?.right_pdf_image_url ||
              procedure_image_data?.patient_image_right_url
            }
            frontImage={
              procedure_drawings_image?.drawing_front_image_with_pins ||
              pdf_image?.front_pdf_image_url ||
              procedure_image_data?.patient_image_front_url
            }
            leftImage={
              procedure_drawings_image?.drawing_left_image_with_pins ||
              pdf_image?.left_pdf_image_url ||
              procedure_image_data?.patient_image_left_url
            }
            openLightbox={openLightbox}
          />
        </>
      )}

      {withBackImage && isCoolSculpting && (
        <>
          <div className="juvly-subtitle m-t-40">Procedure Images - Back</div>
          <ProcedureImagesSet
            drawings_image={undefined}
            rightImage={
              procedure_drawings_image?.drawing_back_right_image_45_with_pins ||
              pdf_image?.back_pdf_image_right_45_thumb_url ||
              procedure_image_data?.patient_image_back_right_45_thumb_url
            }
            frontImage={
              procedure_drawings_image?.drawing_back_image_with_pins ||
              pdf_image?.back_pdf_image_url ||
              procedure_image_data?.patient_image_back_thumb_url
            }
            leftImage={
              procedure_drawings_image?.drawing_back_left_image_45_with_pins ||
              pdf_image?.back_pdf_image_left_45_thumb_url ||
              procedure_image_data?.patient_image_back_left_45_thumb_url
            }
            openLightbox={openLightbox}
          />
        </>
      )}
    </div>
  );
}
